import { useEffect, useState } from 'react';
import { Dropdown, DefaultDropdownProps } from 'framework/form';
import useRoleService from '../roleOnProject/roleService';

const RolesDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => {
  const { findAll } = useRoleService();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    (async () => {
      const roles = await findAll();
      const data = roles.map((role: any) => ({
        value: role.key,
        label: role.name,
      }));
      setOptions(data);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Dropdown {...props} placeholder="Select role" options={options} />;
};

export default RolesDropdown;
